import numeral from 'numeral';

export function cleanNumber(number, allowMinus = false) {
  return number.toString().replace(/\D/gu, (res, idx, whole) => {
    // To properly format string based inputs for numbers,
    // we need to check whether it's the first time a dec
    // separator appears in the string, to prevent 0..0
    // and 0.0.0.0.0 and various other dumb cases.
    if ((res === ',' || res === '.') && whole.indexOf(res) === idx) {
      return '.';
    }

    if (allowMinus && (res === '-') && whole.indexOf(res) === idx && idx === 0) {
      return '-';
    }
    return '';
  });
}

export function clearNumber(value, format, finalFormat, allowMinus = false, allowNull = false) {
  let number = value;
  if (typeof number === 'undefined') {
    return 0;
  }

  number = cleanNumber(number?.toString() || '', allowMinus);
  const lastChar = number.toString().substring(number.toString().length - 1);
  if (lastChar !== '.') {
    if (finalFormat === false && lastChar === '0') {
      return number;
    }

    if (allowMinus && finalFormat === false && lastChar === '-') {
      return number;
    }

    if (allowNull && finalFormat === false && lastChar === '') {
      return number;
    }

    // if last character is not dot, then convert number
    return numeral(number).format(format);
  } else if ((number.toString().match(/\./gu) || []).length > 1 || format === '0') {
    // if there is more than one dot - delete last one.
    return number.toString().substring(0, number.toString().length - 1);
  }
  return number;
}

export function companyDisplayName(company, showTitle = true) {
  if (!company) {
    return '';
  }

  const companyName = `${company.format.replace('{0}', company.name)}`;

  if (company.title) {
    return showTitle ? `${company.title} (${companyName})` : `(${companyName})`;
  }

  return companyName;
}

export function formatDisplayMame(name, format) {
  if (!format) {
    return '';
  }

  return `${format.replace('{0}', name ?? '')}`;
}
